// extracted by mini-css-extract-plugin
module.exports = {"birthday":"profileQuestions_birthday__3hOFg","container":"profileQuestions_container__2CYMG","heading":"profileQuestions_heading__1ZqiX"};